import { services } from '@/mocks/services';
import { Link } from 'react-router-dom';

export default function ServiceSection() {
  return (
    <section className="py-14 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-medium rounded-full mb-3">
            核心服务
          </span>
          <h2 className="font-heading font-bold text-xl md:text-3xl text-foreground-950 mb-3">
            全链路游戏出海解决方案
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            从市场洞察到精准投放，从创意制作到数据分析，覆盖游戏出海每一个关键环节
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {services.map((service) => (
            <div
              key={service.id}
              className="group p-5 md:p-6 bg-background-50 border border-background-200/70 rounded-lg hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-11 h-11 md:w-12 md:h-12 rounded-lg bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${service.icon} text-lg md:text-xl text-primary-600 group-hover:text-background-50 transition-colors duration-300`}></i>
              </div>
              <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-950 mb-2">
                {service.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-4">
                {service.description}
              </p>
              <ul className="space-y-1.5">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center gap-2 text-xs text-foreground-600">
                    <i className="ri-check-line text-primary-500 text-sm"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/about"
            className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors cursor-pointer group"
          >
            了解完整服务详情
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-200"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}